export const darkTheme = {
  colors: {
    primary: "#fff",
    secondary: "#ff4d5a",
    tertiary: "rgba(255,255,255,.5)",

    primary_Hover: "#828c96",
    secondary_Hover: "#de424d",
    tertiary_Hover: "rgba(255,255,255,.75)",
  },

  backgrounds: {
    body: "linear-gradient(to bottom, #072142, #061c37, #07182b, #061220, #020b16);",

    hero: "linear-gradient(to bottom, #072142, #061c37, #07182b, #061220, #020b16);",

    works:
      "linear-gradient(to bottom, #020b16, #061220, #07182b, #061c37, #072142);",

    contact:
      "linear-gradient(to bottom, #020b16, #061220, #07182b, #061c37, #072142);",

    about:
      "linear-gradient(to bottom, #072142, #061c37, #07182b, #061220, #020b16);",

    detailPage_Hero: "#020b16",
  },
};

// background-image: linear-gradient(to bottom, #020b16, #020b16, #020b16, #020b16, #020b16);
